var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e-remove 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7066 1.79279C10.5191 1.60532 10.2648 1.5 9.99959 1.5C9.73443 1.5 9.48012 1.60532 9.29259 1.79279L5.99959 5.08579L2.70659 1.79279C2.51799 1.61063 2.26539 1.50983 2.00319 1.51211C1.74099 1.51439 1.49018 1.61956 1.30477 1.80497C1.11937 1.99038 1.0142 2.24119 1.01192 2.50339C1.00964 2.76558 1.11043 3.01818 1.29259 3.20679L4.58559 6.49979L1.29259 9.79279C1.19708 9.88503 1.1209 9.99538 1.06849 10.1174C1.01608 10.2394 0.988496 10.3706 0.987342 10.5034C0.986189 10.6362 1.01149 10.7678 1.06177 10.8907C1.11205 11.0136 1.18631 11.1253 1.2802 11.2192C1.37409 11.3131 1.48574 11.3873 1.60864 11.4376C1.73154 11.4879 1.86321 11.5132 1.99599 11.512C2.12877 11.5109 2.25999 11.4833 2.382 11.4309C2.504 11.3785 2.61435 11.3023 2.70659 11.2068L5.99959 7.91379L9.29259 11.2068C9.4812 11.3889 9.7338 11.4897 9.99599 11.4875C10.2582 11.4852 10.509 11.38 10.6944 11.1946C10.8798 11.0092 10.985 10.7584 10.9873 10.4962C10.9895 10.234 10.8888 9.98139 10.7066 9.79279L7.41359 6.49979L10.7066 3.20679C10.8941 3.01926 10.9994 2.76495 10.9994 2.49979C10.9994 2.23462 10.8941 1.98031 10.7066 1.79279Z",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationCross);
export default __webpack_public_path__ + "static/media/notification-cross.6deef337c6d03aad9ab93a09ae6077de.svg";
export { ForwardRef as ReactComponent };